module.exports = __webpack_public_path__ + "img/客服.48dfb060.png";